import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

export const campaignPostCountResponseSchema = z.object({
  count: z.number().int().nonnegative(),
});

export async function FetchCampaignPostCount(
  campaignId: string,
  recent: boolean,
  signal?: AbortSignal,
): Promise<number> {
  const endpoint = recent
    ? `campaigns/${campaignId}/recent_posts/count`
    : `campaigns/${campaignId}/posts/count`;
  const response = await socialApiClient.get(endpoint, {
    signal,
  });

  return campaignPostCountResponseSchema.parse(await response.json()).count;
}
